/* SearchOverlay.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _15 = "._t9eczr6s{transform:translateX(-50%)}";
const _14 = "._1ltv1ssb{left:50%}";
const _13 = "._154i1fqw{top:7.5rem}";
const _12 = "._kqswstnw{position:absolute}";
const _11 = "._1bsb1c3h{width:50pc}";
const _10 = "._18s81dzm{margin:var(--ds-space-negative-200)}";
const _9 = "._2rko1j6v{border-radius:1rem}";
const _8 = "._1e0c1ule{display:block}";
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { SearchOverlaySuggestionClickEvent, SearchOverlayViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { SearchDropdownOverlay } from '../SearchDropdown';
const _7 = "._11q76ota{background:var(--ds-surface)}";
const _6 = "._1pbyjbo9{z-index:100000}";
const _5 = "._4t3i1osq{height:100%}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._1ltvidpf{left:0}";
const _2 = "._154iidpf{top:0}";
const _ = "._kqsw1n9t{position:fixed}";
const FullWidthSearchDropdown = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9 _11q76ota", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  FullWidthSearchDropdown.displayName = 'FullWidthSearchDropdown';
}
const Overlay = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _7, _9, _10, _11, _12, _13, _14, _15]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1ule _11q76ota _2rko1j6v _18s81dzm _1bsb1c3h _kqswstnw _154i1fqw _1ltv1ssb _t9eczr6s", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Overlay.displayName = 'Overlay';
}
export function SearchOverlay(_ref3) {
  let {
    onClose,
    analytics
  } = _ref3;
  const {
    value: screenSize
  } = useResponsiveBreakpoint();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleViewedAnalytics = _ref4 => {
    let {
      searchOverlayScreen,
      recentSearchesCount
    } = _ref4;
    fireAnalyticsEvent({
      eventType: SearchOverlayViewEvent,
      actionSubjectId: 'searchOverlayViewed',
      source: analytics.source,
      attributes: {
        searchOverlayScreen,
        recentSearchesCount
      }
    });
  };
  const handleSearchItemSelectionAnalytics = _ref5 => {
    let {
      query,
      position,
      popularity,
      suggestionSource
    } = _ref5;
    fireAnalyticsEvent({
      eventType: SearchOverlaySuggestionClickEvent,
      actionSubjectId: 'searchOverlayItemSelected',
      source: analytics.source,
      attributes: {
        query,
        position,
        popularity,
        suggestionSource
      }
    });
  };
  const searchInput = /*#__PURE__*/React.createElement(SearchDropdownOverlay, {
    onViewed: handleViewedAnalytics,
    closeOverlay: onClose,
    onSuggestionSelection: handleSearchItemSelectionAnalytics
  });
  if (screenSize <= breakpointValues.sm) {
    return /*#__PURE__*/React.createElement(FullWidthSearchDropdown, null, searchInput);
  }
  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
    label: "Search input",
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Overlay, null, searchInput)));
}